// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: 'Nunito Sans' !important;
    color: #391410;
}


/* .ul .li {
    color: #391410;
}

body {
    color: #391410;
} */

.navbar-light .navbar-nav .nav-link {
    /* color: #391410; */
    color: #8c1819
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/navbar/navbar.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,cAAc;AAClB;;;AAGA;;;;;;GAMG;;AAEH;IACI,oBAAoB;IACpB;AACJ","sourcesContent":["* {\r\n    font-family: 'Nunito Sans' !important;\r\n    color: #391410;\r\n}\r\n\r\n\r\n/* .ul .li {\r\n    color: #391410;\r\n}\r\n\r\nbody {\r\n    color: #391410;\r\n} */\r\n\r\n.navbar-light .navbar-nav .nav-link {\r\n    /* color: #391410; */\r\n    color: #8c1819\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
